const buildReservationNavigationTargetUrl = ({
  activeSubPage = "details",
  listContext = {},
  recordId,
  status = "all",
}) => {
  const query = new URLSearchParams({ status: status || "all" });

  ["listId", "workingListId"].forEach(key => {
    const value = listContext[key];
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, value);
    }
  });

  return `/reservations/${recordId}/${activeSubPage || "details"}?${query.toString()}`;
};

export { buildReservationNavigationTargetUrl };
